import React from "react";
import { Basket } from "tsi-common-react/src/apps/checkout/Basket/index";

import { BasketFinePrint } from "./BasketFinePrint";
import { BasketSidebarContent } from "./BasketSidebarContent";

// The basket app's actual render. Loaded only on the client (via BasketApp's
// React.lazy import) because the checkout/basket dependency tree is not
// SSR-safe. The reactivated renderer + the client entry already wrap the
// document in the Redux Provider, so no Provider is needed here.
// The ErrorBoundary lives in BasketApp (wrapping Suspense) so it also catches
// chunk-load failures of this lazy module.
const BasketAppInner = (): React.JSX.Element => (
    <Basket
        getLineProductUpsell={() => {
            return null;
        }}
        showValueProps={true}
        getExtraSummaryContent={() => {
            return null;
        }}
        getExtraSidebarContent={(data, isMobile) => {
            const cartID = data.basket ? data.basket.encoded_basket_id : "";
            return (
                <BasketSidebarContent
                    plans={data.financing_plans}
                    isMobile={isMobile}
                    cartID={cartID}
                />
            );
        }}
        getExtraMainColumnContent={(data, isMobile) => {
            if (isMobile) {
                return null;
            }
            return <BasketFinePrint plans={data.financing_plans} />;
        }}
    />
);

export default BasketAppInner;
